import React, { useEffect } from 'react';
import { Icon } from '@gerdau/hefesto';
import { useDispatch } from 'react-redux';
import { SpinnerIcon } from '../../../../../../../components/Commons/SpinnerIcon/styles';
import { ErrorIcon } from '../../../../../../../components/Commons/Tables/DownloadCellContent/styles';
import {
  downloadQCFile,
  loadQCFile
} from '../../../../../../../store/ducks/long-steel-orders/actions';
import {
  IBilledOrderData,
  IQCFileResponse
} from '../../../../../../../store/ducks/long-steel-orders/types';
import { IconWrapper, Link } from './styles';
import { sendTagging } from '../../../../../../../store/ducks/tagging/actions';
import { GetFlag } from '../../../../../../../utils/featureFlag';
import { addToast } from '../../../../../../../store/ducks/toast/actions';
import { EToastTypes } from '../../../../../../../store/ducks/toast/types';

interface QualityCertificationColumnProps {
  item: IBilledOrderData;
}

const QualityCertificationColumn: React.FC<QualityCertificationColumnProps> = ({
  item
}) => {
  const dispatch = useDispatch();
  const qualityCertificateFlag = GetFlag('cg_certificado_qualidade');

  const downloadFromUseEffect = () => {
    dispatch(downloadQCFile(item));
    downloadFile(item.qcState?.qcFileResponse as IQCFileResponse);
    dispatch(
      addToast({
        message: `Certificado baixado com sucesso!`,
        type: EToastTypes.SUCCESS,
        durationInMS: 3000
      })
    );
  };

  const isNormal = !item?.qcState?.loading && !item?.qcState?.error;
  const isDownloadable = item?.qcState?.canDownloadQC;
  const isLoading = item?.qcState?.loading;
  const hasError = item?.qcState?.error;

  useEffect(() => {
    if (!item?.qcState?.alreadyDownloaded && item?.qcState?.qcFileResponse) {
      downloadFromUseEffect();
    }
  });

  const downloadCQ = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();

    dispatch(
      sendTagging({
        screenName: 'LG:MeusPedidos:AcosLongos:PedidosFaturados',
        event: 'click',
        itemName: 'button:baixar_certificado_de_qualidade',
        itemDescription: `meus_pedidos_acosLongos_pedidosFaturados_baixarCertificadoDeQualidade`
      })
    );

    if (item.qcState.qcFileResponse) {
      downloadFile(item.qcState.qcFileResponse as IQCFileResponse);
    } else {
      dispatch(loadQCFile(item));
    }
  };

  const downloadFile = (qcFileResponse: IQCFileResponse) => {
    const dataurl =
      'data:text/plain;base64,' + qcFileResponse.qcFile.qcBase64File;
    const element = document.createElement('a');
    element.setAttribute('href', dataurl);
    element.setAttribute('download', `cq-${item.invoiceNumber}.pdf`);
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  };

  return (
    <>
      {isDownloadable && isNormal && (
        <IconWrapper onClick={downloadCQ}>
          <Icon
            option={qualityCertificateFlag ? 'ImagePlaceholder' : 'Download'}
            variant="primary"
            size="sm"
          />
          <Link onClick={downloadCQ}>Baixar Certificado</Link>
        </IconWrapper>
      )}

      {isLoading && (
        <>
          <SpinnerIcon style={{ margin: '0.125rem' }} />
          Baixando Certificado
        </>
      )}

      {hasError && !isLoading && (
        <>
          <ErrorIcon />
          Tentar novamente
        </>
      )}

      {!isDownloadable && <Link $disabled>Indisponível</Link>}
    </>
  );
};

export default QualityCertificationColumn;
